/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * User's object.
 * @export
 * @interface UserSignUp
 */
export interface UserSignUp {
    /**
     * user id, unique string required to create new user. It can be email
     * @type {string}
     * @memberof UserSignUp
     */
    uid: string;
    /**
     * first name of the user
     * @type {string}
     * @memberof UserSignUp
     */
    firstName: string;
    /**
     * last name of the user
     * @type {string}
     * @memberof UserSignUp
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof UserSignUp
     */
    titleCode?: string;
    /**
     * User password.
     * @type {string}
     * @memberof UserSignUp
     */
    password: string;
    /**
     * Authentication identifier of a new B2C customer registration. Only needed when OTP for registration is enabled.
     * @type {string}
     * @memberof UserSignUp
     */
    verificationTokenId?: string;
    /**
     * Code included in the email sent to the customer to be registered. Only needed when OTP for registration is enabled.
     * @type {string}
     * @memberof UserSignUp
     */
    verificationTokenCode?: string;
}

/**
 * Check if a given object implements the UserSignUp interface.
 */
export function instanceOfUserSignUp(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "uid" in value;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "lastName" in value;
    isInstance = isInstance && "password" in value;

    return isInstance;
}

export function UserSignUpFromJSON(json: any): UserSignUp {
    return UserSignUpFromJSONTyped(json, false);
}

export function UserSignUpFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserSignUp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uid': json['uid'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'titleCode': !exists(json, 'titleCode') ? undefined : json['titleCode'],
        'password': json['password'],
        'verificationTokenId': !exists(json, 'verificationTokenId') ? undefined : json['verificationTokenId'],
        'verificationTokenCode': !exists(json, 'verificationTokenCode') ? undefined : json['verificationTokenCode'],
    };
}

export function UserSignUpToJSON(value?: UserSignUp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'uid': value.uid,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'titleCode': value.titleCode,
        'password': value.password,
        'verificationTokenId': value.verificationTokenId,
        'verificationTokenCode': value.verificationTokenCode,
    };
}

